import { useState } from 'react';
import { type FloatingContext } from '@floating-ui/react';

import { useSearch } from '@/hooks/use-search';

import { Icon } from '@flintmint/web-shared/components/icon';
import { Button } from '@flintmint/web-shared/components/button';
import { Combobox } from '@flintmint/web-shared/components/combobox';

import { getSortModel } from '@/utils/helper-utils';
import { NewTagPopover } from '@/components/new-tag-popover';

export const TagFilter = (props: TagFilterProps) => {
  const { context, includedTagIds, excludedTagIds, setExcludedTagIds, setIncludedTagIds } = props;

  const [search, setSearch] = useState('');

  const { data } = useSearch({
    term: search,
    where: {
      types: ['tags'],
    },
    tolerance: 0.5,
    sort: getSortModel({ key: 'createdAt', direction: 'desc' }),
  });

  return (
    <Combobox
      search={search}
      selections={includedTagIds}
      exclusions={excludedTagIds}
      context={context}
      onSearchChange={setSearch}
      onSelectionChange={setIncludedTagIds}
      onExclusionChange={setExcludedTagIds}
      data={data.map((el) => ({ ...el.document, color: el.document.content }))}
      inputProps={{
        size: 'small',
        corderRadius: 'smooth',
        appearance: 'filled-darker',
      }}
      addNew={
        <NewTagPopover
          placement="right"
          offset={[36, 12]}
          colorPickerProps={{
            placement: 'top',
            offset: [0, 26],
          }}
          onTagCreate={(newTag) => {
            setIncludedTagIds([...includedTagIds, newTag.id]);
            setSearch('');
          }}
        >
          <Button appearance="plain" icon={<Icon type="plus" size={16} />} data-testid="tag-filter-new-tag-btn">
            New Tag
          </Button>
        </NewTagPopover>
      }
    />
  );
};

export interface TagFilterProps {
  context: FloatingContext;
  includedTagIds: string[];
  excludedTagIds: string[];
  setExcludedTagIds: (ids: string[]) => void;
  setIncludedTagIds: (ids: string[]) => void;
}
